/**
 * WALLY CUSTOM: Brand mega menu interactions.
 * - Desktop: tab switching between brand groups, height recalculation
 * - Mobile: search filtering in brand drawer
 * Re-apply after theme updates.
 */
(function () {
  // Desktop: group tab switching
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-brand-group-btn]');
    if (!btn) return;

    var panelId = btn.getAttribute('data-brand-group-btn');
    var megaMenu = btn.closest('.brand-mega-menu');
    if (!megaMenu) return;

    // Update tabs
    megaMenu.querySelectorAll('[data-brand-group-btn]').forEach(function (b) {
      b.classList.remove('brand-mega-menu__group-btn--active');
      b.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('brand-mega-menu__group-btn--active');
    btn.setAttribute('aria-selected', 'true');

    // Switch panels (visibility toggle, no height change)
    megaMenu.querySelectorAll('[data-brand-panel]').forEach(function (p) {
      if (p.getAttribute('data-brand-panel') === panelId) {
        p.classList.add('brand-mega-menu__panel--active');
      } else {
        p.classList.remove('brand-mega-menu__panel--active');
      }
    });

    // Prevent click from bubbling and closing the menu
    e.stopPropagation();
  });

  // Mobile: brand search filtering
  document.addEventListener('input', function (e) {
    if (!e.target.hasAttribute('data-brand-drawer-search')) return;

    var query = e.target.value.toLowerCase().trim();
    var drawer = e.target.closest('.brand-drawer');
    if (!drawer) return;

    var links = drawer.querySelectorAll('[data-brand-name]');
    var letters = drawer.querySelectorAll('[data-brand-letter]');
    var noResults = drawer.querySelector('[data-brand-no-results]');
    var visibleCount = 0;

    links.forEach(function (link) {
      var name = link.getAttribute('data-brand-name');
      var visible = !query || name.indexOf(query) !== -1;
      link.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    });

    // Show/hide letter headings based on whether they have visible brands
    letters.forEach(function (heading) {
      var letter = heading.getAttribute('data-brand-letter');
      var hasVisible = false;
      var sibling = heading.nextElementSibling;
      while (sibling && !sibling.hasAttribute('data-brand-letter') && !sibling.hasAttribute('data-brand-no-results')) {
        if (sibling.style.display !== 'none') hasVisible = true;
        sibling = sibling.nextElementSibling;
      }
      heading.style.display = hasVisible ? '' : 'none';
    });

    if (noResults) {
      noResults.hidden = visibleCount > 0;
    }
  });
})();
